import api from '../config/api';

const occasionService = {
  async getAll() {
    const response = await api.get('/api/occasions');
    return response.data;
  },
};

export default occasionService;
